const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.nsr.forwoodsafety.com',
    USER_TOKEN_URL: 'https://7kasohlprl.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'ap-southeast-2',
    URL: 'https://2109kc2hf1.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.nsr.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.nsr.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.nsr.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.nsr.forwoodsafety.com',
    WEBSOCKET: 'wss://31o1517wr7.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
